$.fn.nl_google_map = function(event,data) {
    return this.each(function() {
        var $this = $(this);
        if (!$this.length) {
            return false;
        }
        if (event === 'init') {
            nl_google_map_init();
        }
        else if (event === 'markers_add') {
            nl_google_map_markers_add_method();
        }

        else if (event === 'markers_remove') {
            nl_google_map_markers_remove_method();
        }

        else if (event === 'markers_reload') {
            nl_google_map_markers_remove_method();
            nl_google_map_markers_add_method();
        }

        else if (event === 'position') {
            nl_google_map_position_method(data);
        }

        else if (event === 'marker_click') {
            nl_google_map_marker_click_method(data);
        }

        function nl_google_map_init() {
            var $zoom = $this.data("zoom"),
                $coords = $this.data('coords').split(/[\s,]+/),
                $markers = $this.data("markers"),
                $scroll = false,
                $markers_temp = [],
                $map_options = {
                    zoom: $zoom,
                    scrollwheel: false,
                    draggable: false,
                    mapTypeControl: false,
                    disableDefaultUI: false,
                    clicable: false,
                    styles : [
                        {
                            "featureType": "water",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#89ced6"
                                }
                            ]
                        }
                    ],
                    center: {
                        lat: parseFloat($coords[0]), lng: parseFloat($coords[1])
                    }
                };

            var $map = new google.maps.Map($this[0], $map_options);


            if ($this.is("[data-scroll]")) {
                $scroll = true;
            }

            google.maps.event.addListener($map, 'click', function () {
                $map.setOptions({
                    scrollwheel: $scroll, draggable: true
                });
            });

            $(document).on("click", function (e) {
                if ($(e.target).closest($this).length === 0) {
                    $map.setOptions({
                        scrollwheel: false, draggable: false
                    });
                }
            });

            function nl_google_map_position(data) {
                var $location = data.split(/[\s,]+/);
                var latLng = new google.maps.LatLng($location[0],$location[1]);
                $map.panTo(latLng);
                $map.setZoom(17);
            }
            function nl_google_map_markers_add() {
                $markers = $this.data("markers");
                if ($this.filter("[data-marker]").length) {
                    var $main_marker_position = new google.maps.LatLng(parseFloat($coords[0]), parseFloat($coords[1]));
                    var $main_marker_image = {
                        url: $this.data("marker"),
                        anchor: new google.maps.Point(23, 60),
                        scaledSize: new google.maps.Size(45, 60)
                    };

                    var $main_marker = new google.maps.Marker({
                        position: $main_marker_position,
                        map: $map,
                        icon: $main_marker_image
                    });
                    // google.maps.event.addListener($main_marker, 'click', function() {
                    //     window.location.href = $this.data("marker-url")
                    // });
                }

                if ($this.filter("[data-markers]").length) {
                    var $bounds = new google.maps.LatLngBounds();
                    var $infoWindow = new google.maps.InfoWindow({
                        content: "",
                        maxWidth: 266
                    });
                    if ($this.filter("[data-marker]").length) {
                        $markers_temp.push($main_marker);
                        $bounds.extend($main_marker_position);
                    }

                    for (var i = 0; i < $markers.length; i++) {
                        var $marker = $markers[i],
                            $position = new google.maps.LatLng($marker.lat, $marker.lng),
                            $image = {
                                url: $marker.icon,
                                scaledSize: new google.maps.Size(48, 64),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(24, 64)
                            },
                            $icon = new google.maps.Marker({
                                position: $position,
                                map: $map,
                                icon: $image,
                                title: $marker.name,
                                zIndex: $marker.zIndex,
                                about: $marker.about,
                                img: $marker.img
                            });

                        $markers_temp.push($icon);
                        $bounds.extend($position);

                        function showInfo($marker) {
                            return function () {
                                $('html, body').animate({
                                    scrollTop: $('[data-anchor-elm="map"]').offset().top - 70
                                }, 300);
                                var $img = "";
                                if ($marker.img) {
                                    $img = "<div class='elm_image'><img src='"+$marker.img+"'/></div>";
                                }
                                var $content = "<div class='part_ui_info'>"+$img+"<div class='elm_row'><h4>"+$marker.title+"</h4><div class='elm_info'>"+$marker.about+"</div></div>";
                                $map.panTo($marker.position);
                                $infoWindow.setContent($content);
                                $infoWindow.open($map,$marker);
                            }
                        }

                        google.maps.event.addListener($icon, 'click', showInfo($icon));

                        google.maps.event.addListener($infoWindow, 'domready', function() {
                            $('.part_ui_info').closest('.gm-style-iw').parent().addClass('gm-custom-iw');
                        });
                    }

                    google.maps.event.addListenerOnce($map, 'bounds_changed', function() {
                        if(this.getZoom() < $zoom) {
                            this.setZoom($zoom);
                        }
                    });

                    $map.fitBounds($bounds);
                }

                function nl_google_map_markers_remove() {
                    for (var i = 0; i < $markers_temp.length; i++) {
                        $markers_temp[i].setMap(null);
                    }

                    $markers_temp = [];
                }
                window.nl_google_map_markers_remove_method = nl_google_map_markers_remove;
            }
            function nl_google_map_marker_click(index) {
                google.maps.event.trigger($markers_temp[index], 'click');
            }

            window.nl_google_map_markers_add_method = nl_google_map_markers_add;
            window.nl_google_map_position_method = nl_google_map_position;
            window.nl_google_map_marker_click_method = nl_google_map_marker_click;
        }
    });
};